import * as React from 'react';
import clazz from 'classnames';
import { Icon } from 'antd';
import styles from './style/index.less';
/**
 * desc 气泡提示
 * @params visiable : 是否展示
 * @params icon : 图标
 * @params msg : 提示语
 * @params direction ：方向
 * */
class PopoverTip extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style: {},
        };
        this.popoverContainer = React.createRef();
        this.popoverDiv = React.createRef();
        this.dealOffset = this.dealOffset.bind(this);
    }
    dealOffset() {
        const { direction } = this.props;
        const style = {};
        if (!this.popoverContainer.current) {
            return;
        }
        const containerWidth = this.popoverContainer.current.offsetWidth;
        const containerHeight = this.popoverContainer.current.offsetHeight;
        const divWidth = this.popoverDiv.current.offsetWidth;
        const divHeight = this.popoverDiv.current.offsetHeight;
        switch (direction) {
            case 'left':
            case 'right':
                const top = (containerHeight - divHeight) / 2;
                style.top = top;
                break;
            case 'top':
            case 'bottom':
                const left = (containerWidth - divWidth) / 2;
                style.left = left;
                break;
        }
        this.setState({
            style,
        });
    }
    render() {
        const { msg, direction, visible, icon } = this.props;
        setTimeout(this.dealOffset);
        return (<div className={clazz(styles.popover_container, 'popover_container_calc')} ref={this.popoverContainer}>
        <div className={clazz(styles.popover_div, {
            [styles.div_top]: direction === 'top',
            [styles.div_bottom]: direction === 'bottom',
            [styles.div_left]: direction === 'left',
            [styles.div_right]: direction === 'right',
            [styles.div_hide]: !visible,
        })} ref={this.popoverDiv} style={this.state.style}>
          <div className={styles.popover_border}>
            {icon}
            <div className={styles.popover_title}>{msg}</div>
            <div className={clazz({
            [styles.popover_angle_top]: direction === 'top',
            [styles.popover_angle_bottom]: direction === 'bottom',
            [styles.popover_angle_left]: direction === 'left',
            [styles.popover_angle_right]: direction === 'right',
        })}/>
          </div>
        </div>
        {this.props.children}
      </div>);
    }
}
PopoverTip.defaultProps = {
    direction: 'top',
    visible: true,
    icon: (<Icon type="exclamation-circle" theme="filled" style={{
        color: '#FF9900',
        fontSize: '16px',
    }}/>),
};
export default PopoverTip;
